<div class="limits-container" *ngIf="currentUser?.monthSessions">
  <div class="sessions-count">
<!--    <h2>{{'TRAINING_PREPARE.SESSIONS_COUNT' | translate}}-->
<!--      <span class="material-symbols-outlined">-->
<!--        schedule-->
<!--      </span>-->
<!--    </h2>-->
    <p>{{'TRAINING_PREPARE.LEFT_PER_MONTH' | translate}} <span class="limit-value">{{convertMonthTime(currentUser.monthSessions.monthTimeLeft)}}</span></p>
    <p *ngIf="currentUser.monthSessions.dayLimitReached && currentUser.monthSessions.monthTimeLeft !== 0">{{'TRAINING_PREPARE.NEXT_SESSION_AVAILABLE' | translate}} <span class="limit-value">{{convertHoursToHHMM(currentUser?.monthSessions.nextSessionAvailableInHours)}}</span></p>
    <p *ngIf="currentUser.monthSessions.monthTimeLeft <= 0">{{'TRAINING_PREPARE.LIMIT_REACHED' | translate}}</p>
  </div>
</div>
